import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/*
SPDX-FileCopyrightText: 2024 Genome Research Ltd.

SPDX-License-Identifier: MIT
*/
import { initialiseFieldMeta } from "./Field";
import { BoardFilters, Button, RemoteTable, TsDataSource } from "../index";
import { useState } from "react";
import { upsertComponentConfig } from "../boards/utils";
function BoardTable(props) {
    const { id, objectType } = props;
    const ds = new TsDataSource();
    const [config, setConfig] = useState(props.config);
    const [forceUpdate, setForceUpdate] = useState(true);
    const [openFilters, setOpenFilters] = useState(false);
    const onModalSave = (fm) => {
        config["fieldMeta"] = fm;
        setForceUpdate(!forceUpdate); // fetches new data on save
        setConfig({ ...config });
        upsertComponentConfig(ds, id, config);
    };
    const onToggleFilterVisibility = (visible) => {
        config["filterVisibility"] = visible;
        setConfig({ ...config });
        upsertComponentConfig(ds, id, config);
    };
    const onPageSizeChange = (pageSize) => {
        config["pageSize"] = pageSize;
        setConfig({ ...config });
        upsertComponentConfig(ds, id, config);
    };
    const configButtons = [
        _jsxs("span", { children: [_jsx(Button, { outline: true, position: "right", type: "primary", onClick: () => setOpenFilters(true), icon: "filter" }), _jsx(BoardFilters, { endpoint: objectType, entityType: "component", open: openFilters, setOpen: setOpenFilters, ...props })] }, "board-table-filter"),
    ];
    return (_jsx(RemoteTable, { displaySource: true, endpoint: objectType, fieldMeta: config.fieldMeta || initialiseFieldMeta(), pageSize: config.pageSize || 50, filterVisibility: config.filterVisibility ?? true, defaultSort: config?.fieldMeta?.order?.active[0] || undefined, onModalSave: onModalSave, onToggleFilterVisibility: onToggleFilterVisibility, onPageSizeChange: onPageSizeChange, forceUpdate: forceUpdate, configButtons: configButtons, ...props }));
}
export default BoardTable;
